import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { radioButtonDriverFactory } from './RadioButton.driver';
import { RadioButton } from './RadioButton';
import { Simulate } from 'react-dom/test-utils';

describe('RadioButton', () => {
  const createDriver = createRendererWithUniDriver(radioButtonDriverFactory);
  const subtext = 'This is some subtext';

  const defProps = {
    onChange: () => {},
    label: 'label',
    value: 'value',
  };

  it('should render', async () => {
    const { driver } = createDriver(<RadioButton {...defProps} />);
    expect(await driver.exists()).toBe(true);
  });

  it('should set lang to root', async () => {
    const lang = 'he';
    const { driver } = createDriver(<RadioButton lang={lang} {...defProps} />);

    expect(await driver.getLang()).toBe(lang);
  });
  it('should show checked state', async () => {
    const { driver } = createDriver(<RadioButton checked {...defProps} />);
    expect(await driver.isChecked()).toBeTruthy();
  });

  it('should show disabled state', async () => {
    const { driver } = createDriver(<RadioButton disabled {...defProps} />);
    expect(await driver.isDisabled()).toBeTruthy();
  });

  it('should show required state', async () => {
    const { driver } = createDriver(<RadioButton required {...defProps} />);
    expect(await driver.isRequired()).toBeTruthy();
  });

  it('should lose focus state on blur', async () => {
    const { driver } = createDriver(<RadioButton {...defProps} />);
    await driver.clickInput();
    expect(await driver.isFocused()).toBeTruthy();
    Simulate.blur(await driver.getInput());
    expect(await driver.isFocused()).toBeFalsy();
  });

  it('should trigger onFocus prop', async () => {
    const onFocus = jest.fn();
    const { driver } = createDriver(
      <RadioButton onFocus={onFocus} {...defProps} />,
    );
    const inputElement = await driver.getInput();
    // Focus event isn't triggered in JSDom
    Simulate.focus(inputElement);
    expect(onFocus).toBeCalledTimes(1);
  });

  it('should trigger onBlur prop', async () => {
    const onBlur = jest.fn();
    const { driver } = createDriver(
      <RadioButton onBlur={onBlur} {...defProps} />,
    );
    const inputElement = await driver.getInput();
    // Focus event isn't triggered in JSDom
    Simulate.blur(inputElement);
    expect(onBlur).toBeCalledTimes(1);
  });

  it('should get subtext text', async () => {
    const { driver } = createDriver(
      <RadioButton {...defProps} subtext={subtext} />,
    );
    expect(await driver.getSubtextText()).toBe(subtext);
  });

  describe('ref', () => {
    it('should allow focusing inner input', async () => {
      const ref = React.createRef<RadioButton>();
      const { driver } = createDriver(<RadioButton ref={ref} {...defProps} />);
      expect(await driver.isFocused()).toBeFalsy();
      ref.current.focus();
      expect(await driver.isFocused()).toBeTruthy();
    });

    it('should allow blurring inner input', async () => {
      const ref = React.createRef<RadioButton>();
      const { driver } = createDriver(<RadioButton ref={ref} {...defProps} />);
      const inputElement = await driver.getInput();
      ref.current.focus();
      expect(await driver.isFocused()).toBeTruthy();
      ref.current.blur();
      expect(document.activeElement).not.toBe(inputElement);
      // Blur event isn't triggered in JSDom
      Simulate.blur(inputElement);
      expect(await driver.isFocused()).toBeFalsy();
    });
  });
});
